import React from 'react';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import TagFacesTwoToneIcon from '@material-ui/icons/TagFacesTwoTone';
import FlagIcon from '@material-ui/icons/Flag';
import CheckCircleTwoToneIcon from '@material-ui/icons/CheckCircleTwoTone';
import CancelTwoToneIcon from '@material-ui/icons/CancelTwoTone';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import ThumbUpAltTwoToneIcon from '@material-ui/icons/ThumbUpAltTwoTone';
import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled';
import BackspaceTwoToneIcon from '@material-ui/icons/BackspaceTwoTone';
import FeaturedPlayListIcon from '@material-ui/icons/FeaturedPlayList';
import MonetizationOnTwoToneIcon from '@material-ui/icons/MonetizationOnTwoTone';
import AccessTimeTwoToneIcon from '@material-ui/icons/AccessTimeTwoTone';
import PlayCircleFilledWhiteTwoToneIcon from '@material-ui/icons/PlayCircleFilledWhiteTwoTone';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import ScheduleTwoToneIcon from '@material-ui/icons/ScheduleTwoTone';
import AccountCircleTwoToneIcon from '@material-ui/icons/AccountCircleTwoTone';
import DirectionsCarTwoToneIcon from '@material-ui/icons/DirectionsCarTwoTone';
import DevicesOtherIcon from '@material-ui/icons/DevicesOther';

function ChangeIcon({MobilStatusId}) {
    
console.log(MobilStatusId);
    return (   
(MobilStatusId === 1 ? <AddCircleTwoToneIcon style={{color:'#008000'}} /> :
 (MobilStatusId === 2 ? <TagFacesTwoToneIcon style={{color:'#0000FF'}} /> : 
 (MobilStatusId === 3 ? <FlagIcon style={{color:'#FFFF00 '}} /> :
  (MobilStatusId === 4 ? <CheckCircleTwoToneIcon style={{color:'#800080 '}} /> :
   (MobilStatusId === 5 ? <CancelTwoToneIcon style={{color:'#FFA500 '}} /> :
    (MobilStatusId === 6 ? <ShoppingBasketTwoToneIcon style={{color:'#8000000'}} /> :
     (MobilStatusId === 7 ? <ThumbDownAltIcon style={{color:'#FF0000 '}} /> : 
      (MobilStatusId === 8 ? <HourglassEmptyIcon style={{color:'#008080'}} /> : 
       (MobilStatusId === 9 ? <ThumbUpAltTwoToneIcon style={{color:'#00FF00'}} /> :
         (MobilStatusId === 10 ? <HourglassFullIcon style={{color:'#808000'}} /> :
          (MobilStatusId === 11 ? <PauseCircleFilledIcon style={{color:'#000080'}} /> : 
           (MobilStatusId === 12 ? <BackspaceTwoToneIcon style={{color:'#FFFFF0'}} /> :  
           (MobilStatusId === 13 ? <FeaturedPlayListIcon style={{color:'#000000'}} /> :  
            (MobilStatusId=== 14 ? <DevicesOtherIcon style={{color:'# 483d8b'}} /> : 
             (MobilStatusId === 15 ? <MonetizationOnTwoToneIcon style={{color:'# 00ff7f'}} /> : 
              (MobilStatusId === 16 ? <AccessTimeTwoToneIcon  style={{color:'# ffc125'}} /> :
               (MobilStatusId === 17 ? <ThumbDownAltIcon style={{color:'# cd5555'}} /> :
                (MobilStatusId=== 18 ? <PlayCircleFilledWhiteTwoToneIcon style={{color:'# f08080'}} /> : 
                (MobilStatusId === 19 ? <PlaylistAddIcon style={{color:'# ff1493'}} /> : 
                 (MobilStatusId === 20 ? <ScheduleTwoToneIcon style={{color:'# ee7ae9'}} /> : 
                  (MobilStatusId === 21 ? <AccountCircleTwoToneIcon style={{color:'# 9f79ee'}} /> : 
                   (MobilStatusId === 22 ? <ThumbUpAltTwoToneIcon style={{color:'# ffde66'}} /> :
                    (MobilStatusId === 33 ? <PlayCircleFilledWhiteTwoToneIcon style={{color:'# ffe1ff'}} /> : 
                     (MobilStatusId === 42 ? <DirectionsCarTwoToneIcon style={{color:'# c71585'}} /> :
                     <TagFacesTwoToneIcon style={{color:'# cd9b9b'}} />)))))))))))))))))))))))) 

    );

}


export default ChangeIcon;